/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContractFieldType, ContractStatusType } from "./api";
import { HttpClient, RequestParams } from "./httpClient";

export class TenderMetadata<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Return a list of all leg fields and default values
   *
   * @tags Tender
   * @name DefaultFieldsList
   * @summary Get default fields and values for tender
   * @request GET:/tenderMetadata/defaultFields
   * @secure
   */
  defaultFieldsList = (params: RequestParams = {}) =>
    this.request<
      {
        /** @format date-time */
        activeAt: Date;
        /** @format date-time */
        expiredAt: Date;
        /** @format date-time */
        defaultResponseDueAt: Date;
        fields?: {
          name: string;
          displayName: string;
          isActive: boolean;
          isRequired: boolean;
          isConfigurable: boolean;
          /** @format contract-field-enum */
          fieldType: ContractFieldType;
          /** @format date-time */
          createdAt?: Date;
          /** @format date-time */
          updatedAt?: Date;
        }[];
        surcharges?: {
          name: string;
          displayName: string;
          isActive: boolean;
          isRequired: boolean;
          isConfigurable: boolean;
          /** @format contract-field-enum */
          fieldType: ContractFieldType;
          /** @format date-time */
          createdAt?: Date;
          /** @format date-time */
          updatedAt?: Date;
        }[];
        freeTimes?: {
          name: string;
          displayName: string;
          isActive: boolean;
          isRequired: boolean;
          isConfigurable: boolean;
          /** @format contract-field-enum */
          fieldType: ContractFieldType;
          /** @format date-time */
          createdAt?: Date;
          /** @format date-time */
          updatedAt?: Date;
        }[];
        carrierList?: {
          uid: string;
          name: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
        }[];
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/tenderMetadata/defaultFields`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return a list of all available contract years
   *
   * @tags Tender
   * @name ContractYearsList
   * @summary Get available contract years
   * @request GET:/tenderMetadata/contractYears
   * @secure
   */
  contractYearsList = (params: RequestParams = {}) =>
    this.request<
      {
        years: number[];
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/tenderMetadata/contractYears`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return a list of all contract statuses available
   *
   * @tags Tender
   * @name ContractStatusesList
   * @summary Get available contract statuses
   * @request GET:/tenderMetadata/contractStatuses
   * @secure
   */
  contractStatusesList = (params: RequestParams = {}) =>
    this.request<
      {
        statuses: ContractStatusType[];
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/tenderMetadata/contractStatuses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
